/* Auth calls, typed by the contract in @oneshot2pac/shared.
 *
 * There is no signup — the owner invites, and accepting the invitation creates
 * the membership (IDEA.md §9). */
import type {
  AcceptInvitationRequest,
  ChangePasswordRequest,
  CreateInvitationRequest,
  CreateInvitationResponse,
  InvitationDto,
  InvitationPreviewResponse,
  LoginRequest,
  SessionDto,
} from '@oneshot2pac/shared';
import { api } from './client';

export const authApi = {
  /** Who is signed in. Called once on boot; a 401 means "show the sign-in
   *  screen", not "something went wrong". */
  session: () => api.get<SessionDto>('/auth/session'),

  login: (body: LoginRequest) => api.post<SessionDto>('/auth/login', body),

  logout: () => api.post<void>('/auth/logout'),

  changePassword: (body: ChangePasswordRequest) => api.post<void>('/auth/change-password', body),
};

export const invitationApi = {
  /** Unauthenticated: what the person opening the link is shown before they
   *  set a password. */
  preview: (token: string) => api.get<InvitationPreviewResponse>(`/invitations/${token}`),

  accept: (body: AcceptInvitationRequest) =>
    api.post<SessionDto>(`/invitations/${body.token}/accept`, {
      name: body.name,
      password: body.password,
    }),

  listPending: () => api.get<InvitationDto[]>('/people/invitations'),

  create: (body: CreateInvitationRequest) =>
    api.post<CreateInvitationResponse>('/people/invitations', body),

  revoke: (id: string) => api.del<void>(`/people/invitations/${id}`),
};
